import React from 'react'
import { useSelector } from 'react-redux'
import Modal from '~/components/common/modal'

import { translate } from '~/core/translate'
import { getDialogProps } from '~/selectors/ui'
import ChatList from './list'

const ChatDialog = () => {
  const { id } = useSelector(getDialogProps)

  return (
    <Modal title={translate('meeting_chat')}>
      <ChatList id={id} tabbable />
    </Modal>
  )
}

export default ChatDialog
